'use strict';

import angular from 'angular';

import {LanguageController} from './language.controller';
import {LanguageService} from './language.service';


export default angular.module('dalApp.language', [])
  .service('LanguageService', LanguageService)
  .controller('LanguageController', LanguageController)
  .name;



// WEBPACK FOOTER //
// ./client/components/language/language.module.js